var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrimaryButtonA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 23,
    viewBox: "0 0 47 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Primary_Button",
    "data-name": "Primary Button",
    transform: "translate(-0.17)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8874",
    "data-name": "Rectangle 8874",
    width: 47,
    height: 23,
    rx: 2,
    transform: "translate(0.17)",
    fill: "#2067ed"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Primary_Button-2",
    "data-name": "Primary Button",
    transform: "translate(8 15)",
    fill: "#fff",
    fontSize: 8,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u0632\u0631 \u0623\u0633\u0627\u0633\u064A")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrimaryButtonA);
export default __webpack_public_path__ + "static/media/PrimaryButtonA.e2f7113c1f94ee63e50e40f0c407ed5d.svg";
export { ForwardRef as ReactComponent };